import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { LayersService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class LayerListBloc extends Bloc<LayersService['layerControllerGet']> {
    public constructor(service: LayersService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.layerControllerGet.bind(service), {
            debug: debug ?? false,
        });
    }
}
